
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"18","height":"18","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M17.518 3.214h-2.09V15.43a1.286 1.286 0 002.572 0V3.697a.482.482 0 00-.482-.483z","fill":"#AFAFAF"}}),_c('path',{attrs:{"d":"M16.037 17.91a2.576 2.576 0 01-1.894-2.482V.482A.482.482 0 0013.66 0H.482A.482.482 0 000 .482V15.75A2.25 2.25 0 002.25 18h13.775a.046.046 0 00.04-.072.045.045 0 00-.028-.018zM2.571 7.07V3.214H6.43v3.857H2.57zm9 7.715h-9V13.5h9v1.286zm0-2.572h-9V10.93h9v1.285zm0-2.571h-9V8.357h9v1.286zm0-2.572H7.714V5.786h3.857V7.07zm0-2.571H7.714V3.214h3.857V4.5z","fill":"#AFAFAF"}})])
          )
        }
      }
    